<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre del Torneo</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Organizador</label>
                <select
                  v-model="filters.companyId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="company.id"
                    v-for="(company, i) of itemsCompany"
                    :key="i"
                  >
                    {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Torneo</label>
                <select
                  v-model="filters.tournamentStatusId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournamentStatus"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select
                  v-model="filters.isActive"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getTournaments(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
                <RouterLink to="/tournament/create">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Torneo</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Torneo</th>
                <th scope="col" class="text-center">Organizador</th>
                <th scope="col" class="text-center">Fecha Inicio</th>
                <th scope="col" class="text-center">Fecha Fin</th>
                <th scope="col" class="text-center">Estado Torneo</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">Nro. <br />Partidos</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td>{{ item.name }}</td>
                <td class="text-body">{{ item.company.name }}</td>
                <td class="text-body">{{ item.startDateTimeString }}</td>
                <td class="text-body">{{ item.endDateTimeString }}</td>
                <td class="text-body text-center">
                  {{ item.tournamentStatus.name }}
                </td>
                <td class="text-body text-center">
                  <span
                    @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    role="button"
                    :class="computeStatusClass(item.isActive)"
                  >
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                  </span>
                </td>
                <td class="text-body">{{ item.totalMatches }}</td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                <td class="text-center">
                  <div class="">
                    <RouterLink :to="`/tournament/edit/${item.id}`">
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                    <button
                      v-if="
                        item.tournamentStatus && item.tournamentStatus.id === 3
                      "
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="confirmCloseTournament(item.id)"
                      title="Cerrar torneo"
                    >
                      <i class="material-symbols-outlined fs-16 text-danger">
                        lock
                      </i>
                    </button>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="socialNetworkModal(item.id)"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        share
                      </i>
                    </button>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="downloadModal(item.id)"
                      title="Lista de descargas"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        download
                      </i>
                    </button>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="duplicateModal(item.id, item.name)"
                        title="Duplicar Torneo"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        content_copy
                      </i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlSocialNetwork"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlSocialNetworkLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlSocialNetworkLabel">
            Redes Sociales: Torneo {{ tournament.name }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- Twitter -->
          <div class="mb-4">
            <label class="form-label fw-bold">
              <i data-feather="twitter"></i> Twitter
            </label>
            <textarea
              class="form-control mb-2"
              rows="2"
              v-model="formSocialNetwork.Twitter"
              placeholder="Escribe el texto para Twitter..."
            ></textarea>
            <div class="input-error small mb-1">
              {{ errorsSocialNetwork.Twitter }}
            </div>
            <button
              class="btn btn-outline-primary btn-sm"
              @click="validateAndSaveSocialNetwork('Twitter')"
            >
              Guardar Twitter
            </button>
          </div>

          <!-- Facebook -->
          <div class="mb-4">
            <label class="form-label fw-bold">
              <i data-feather="facebook"></i> Facebook
            </label>
            <textarea
              class="form-control mb-2"
              rows="2"
              v-model="formSocialNetwork.Facebook"
              placeholder="Escribe el texto para Facebook..."
            ></textarea>
            <div class="input-error small mb-1">
              {{ errorsSocialNetwork.Facebook }}
            </div>
            <button
              class="btn btn-outline-primary btn-sm"
              @click="validateAndSaveSocialNetwork('Facebook')"
            >
              Guardar Facebook
            </button>
          </div>

          <!-- WhatsApp -->
          <div>
            <label class="form-label fw-bold">
              <i data-feather="whatsapp"></i> WhatsApp
            </label>
            <textarea
              class="form-control mb-2"
              rows="2"
              v-model="formSocialNetwork.Whatsapp"
              placeholder="Escribe el texto para WhatsApp..."
            ></textarea>
            <div class="input-error small mb-1">
              {{ errorsSocialNetwork.Whatsapp }}
            </div>
            <button
              class="btn btn-outline-primary btn-sm"
              @click="validateAndSaveSocialNetwork('Whatsapp')"
            >
              Guardar WhatsApp
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    id="mdlDownload"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlDownloadLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content" style="width: 155%">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlDownloadLabel"></h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-8">
              <button
                type="button"
                class="btn btn-primary text-white"
                @click="createTournamentUploadContentProcess"
              >
                Generar ZIP
              </button>
            </div>
          </div>
          <div class="default-table-area style-two default-table-width">
            <div class="table-responsive">
              <table class="table align-middle">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" class="text-center">Nombre de Zip</th>
                    <th scope="col" class="text-center">Estado</th>
                    <th scope="col" class="text-center">
                      Creado<br />
                      por
                    </th>
                    <th scope="col" class="text-center">
                      Fecha <br />creación
                    </th>
                    <th scope="col" class="text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in itemDownload" :key="item.id">
                    <td>
                      {{ index + 1 }}
                    </td>
                    <td>{{ item.zipName || "-" }}</td>
                    <td>{{ item.statusDescription }}</td>
                    <td class="text-body">{{ item.createdBy }}</td>
                    <td class="text-body">
                      {{ item.createdAtDateTimeString }}
                    </td>
                    <td class="text-center">
                      <div class="">
                        <button
                          v-if="!item.isDownload"
                          class="ps-2 border-0 bg-transparent lh-1 position-relative"
                          title="Descarga no disponible"
                        >
                          <i
                            class="material-symbols-outlined fs-16 text-secondary ps-2"
                          >
                            download_for_offline
                          </i>
                        </button>
                        <button
                          v-else
                          class="ps-2 border-0 bg-transparent lh-1 position-relative"
                          @click="downloadZip(item.id, item.zipName)"
                          title="Descargas ZIP"
                        >
                          <i
                            class="material-symbols-outlined fs-16 text-primary ps-2"
                          >
                            download_for_offline
                          </i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    id="mdlDuplicate"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlDuplicateLabel"
    aria-hidden="true"
    size="large"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlDuplicateLabel">
            Duplicar Torneo: {{ duplicateTournament.originalName }}
          </h1>
        </div>
        <div class="modal-body">
          <form @submit.prevent="validateForm">
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary">Nombre</label>
                  <input
                    type="text"
                    class="form-control h-45"
                    placeholder="Ingresar el nombre del torneo"
                    v-model="duplicateTournament.name"
                    @input="clearError('name')"
                  />
                  <div v-if="errors" class="input-error">
                    {{ errors.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong"
                    >Fecha Inicio</label
                  >
                  <VueDatePicker
                    placeholder="Fecha y hora"
                    v-model="duplicateTournament.startDate"
                    format="dd/MM/yyyy HH:mm"
                    :format-locale="es"
                    @input="clearError('startDate')"
                    :minutes-increment="30"
                    :enable-time-picker="true"
                    is-24
                    teleport
                  />
                  <div class="input-error">{{ errors.startDate }}</div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong">Fecha Fin</label>
                  <VueDatePicker
                    placeholder="Fecha y hora"
                    v-model="duplicateTournament.endDate"
                    format="dd/MM/yyyy HH:mm"
                    :format-locale="es"
                    @input="clearError('endDate')"
                    :minutes-increment="30"
                    :enable-time-picker="true"
                    is-24
                    teleport
                  />
                  <div class="input-error">{{ errors.endDate }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-6">
                <div class="form-group mb-4"></div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading"> Duplicar Torneo</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
              <button
                type="button"
                class="btn btn-danger text-white"
                 @click="closeDuplicateTournament"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import {
  PAGINATION_ITEMS_PER_PAGE,
  STATUS,
  LABELS,
  COMPANY_TYPES,
  SOCIAL_NETWORKS,
} from "@/utils/constants";
import * as yup from "yup";
import { tournamentDuplicateSchema } from "@/schemas/tournamentDuplicateSchema";
import moment from "moment";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Tournaments",
  components: {
    Pagination,
    OverlayLoader,
  },
  setup() {
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const tournament = ref<any>({});
    const isModalSocialNetworks = ref(false);
    const itemsTournamentStatus = ref<any[]>([]);
    const itemsCompany = ref<any[]>([]);
    const items = ref<any[]>([]);
    const itemDownload = ref<any[]>([]);
    const modalDuplicate = ref<any>(null);
    const tournamentId = ref(0);
    const errors = ref<Record<string, string>>({});
    const filters = ref({
      name: "",
      companyId: null,
      tournamentStatusId: null,
      isActive: null,
    });
    const duplicateTournament = ref({
      tournamentId: 0,
      name: "",
      startDate: "",
      endDate: "",
      originalName: "",
    });
    const tournamentUploadContentProcess = ref({
      id: 0,
      tournamentId: 0,
    });
    const modalSocialNetwork = ref<any>(null);
    const modalDownload = ref<any>(null);

    const formSocialNetwork = reactive({
      Twitter: "",
      Facebook: "",
      Whatsapp: "",
    });

    const errorsSocialNetwork = reactive({
      Twitter: "",
      Facebook: "",
      Whatsapp: "",
    });

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      await getTournamentStatus();
      await getCompanies();
      await getTournaments(currentPage.value);

      const modalElement = document.getElementById("mdlSocialNetwork");
      if (modalElement && window.bootstrap) {
        modalSocialNetwork.value = new window.bootstrap.Modal(modalElement);
        modalSocialNetwork.value.hide();
      }

      const modalElementDuplicate = document.getElementById("mdlDuplicate");
      if (modalElementDuplicate) {
        modalDuplicate.value = new window.bootstrap.Modal(
          modalElementDuplicate
        );
        modalDuplicate.value.hide();
      }

      const modalElementDownload = document.getElementById("mdlDownload");
      if (modalElementDownload && window.bootstrap) {
        modalDownload.value = new window.bootstrap.Modal(modalElementDownload);
        modalDownload.value.hide();
      }
    });

    const duplicateModal = async (id: number, name: string) => {
      try {
        duplicateTournament.value.tournamentId = id;
        duplicateTournament.value.originalName = name;
        modalDuplicate.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };
    const validateForm = async () => {
      try {
        errors.value = {};
        await tournamentDuplicateSchema.validate(duplicateTournament.value, {
          abortEarly: false,
        });
        isLoading.value = true;

        await createTournamentDuplicate();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };
    const createTournamentDuplicate = async () => {
      try {
        const payload = {
          ...duplicateTournament.value,
          startDate: moment(duplicateTournament.value.startDate).toISOString(),
          endDate: moment(duplicateTournament.value.endDate).toISOString(),
        };
        const response: any = await api.post(
          `/tournament/tournament-duplicate`,
          payload
        );
        if (response.data != 0) {
          toast.success(`El Torneo por duplicar fue creado con éxito.`, {
            timeout: 2000,
          });
          closeDuplicateTournament();
          getTournaments(currentPage.value);
        }
      } catch (ex: any) {
        console.error(ex);
        let mensaje = "El Torneo por duplicar no pudo ser creado.";
        if (ex.response?.data) {
          const raw = ex.response.data;
          if (typeof raw === "string") {
            const match = raw.match(/System\.Exception:\s*(.*)/);
            mensaje = match ? match[1] : raw;
          }
        }
        toast.error(mensaje, {
          timeout: 2000,
        });
      }
    };
    const closeDuplicateTournament = () => {
      clearDuplicateTournament();
      modalDuplicate.value.hide();
    };
    const clearDuplicateTournament = () => {
      duplicateTournament.value.originalName = "";
      duplicateTournament.value.tournamentId = 0;
      duplicateTournament.value.name = "";
      duplicateTournament.value.startDate = "";
      duplicateTournament.value.endDate = "";
    };
    const clearError = (field: string) => {
      errors.value[field] = "";
    };
    const getTournamentStatus = async () => {
      try {
        const response = await api.get(`/common/tournamentStatus`);
        itemsTournamentStatus.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PROMOTOR}`
        );
        itemsCompany.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getTournaments = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (filters.value.companyId) {
          params = params + `&companyId=${filters.value.companyId}`;
        }
        if (filters.value.tournamentStatusId) {
          params =
            params + `&tournamentStatusId=${filters.value.tournamentStatusId}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/tournament?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getTournaments(currentPage.value);
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> el Torneo?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/tournament`, obj);

        if (response != 0) {
          toast.success(
            `El torneo fue ${status ? "desactivado" : "activado"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `El torneo no pudo ser ${status ? "desactivado" : "activado"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };

    const confirmCloseTournament = async (id: number) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>CERRAR</b> el torneo?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, cerrar",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;
        try {
          const response: any = await api.put(`/tournament/close/${id}`);
          if (response != 0) {
            toast.success("El torneo fue cerrado con éxito.", {
              timeout: 2000,
            });
            fetchPage(currentPage.value);
          } else {
            toast.error("El torneo no pudo ser cerrado.", { timeout: 2000 });
          }
        } catch (ex) {
          toast.error("Ocurrió un error al cerrar el torneo.", {
            timeout: 2000,
          });
          console.error(ex);
        } finally {
          isLoading.value = false;
        }
      }
    };

    const socialNetworkModal = async (id: number) => {
      try {
        tournament.value = items.value.find((f) => f.id === id);

        const response = await api.get(`/tournament/socialNetworks/${id}`);
        const itemsSocialNetworks =
          response.data && response.data.socialNetworkInfo;

        formSocialNetwork.Twitter = itemsSocialNetworks.find(
          (t: { socialNetworkType: { id: number } }) =>
            t.socialNetworkType.id === SOCIAL_NETWORKS.TWITTER
        )?.shareText;
        formSocialNetwork.Facebook = itemsSocialNetworks.find(
          (t: { socialNetworkType: { id: number } }) =>
            t.socialNetworkType.id === SOCIAL_NETWORKS.FACEBOOK
        )?.shareText;
        formSocialNetwork.Whatsapp = itemsSocialNetworks.find(
          (t: { socialNetworkType: { id: number } }) =>
            t.socialNetworkType.id === SOCIAL_NETWORKS.WHATSAPP
        )?.shareText;

        modalSocialNetwork.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };
    const downloadModal = async (id: number) => {
      try {
        tournamentId.value = id;
        const response = await api.get(`/tournament/tournamentsProcess/${id}`);
        itemDownload.value = response.data.list;
        modalDownload.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    const schemaSocialNetwork = yup.object({
      Twitter: yup.string().required("El mensaje de Twitter es obligatorio"),
      Facebook: yup.string().required("El mensaje de Facebook es obligatorio"),
      Whatsapp: yup.string().required("El mensaje de WhatsApp es obligatorio"),
    });

    const validateAndSaveSocialNetwork = async (
      field: "Twitter" | "Facebook" | "Whatsapp"
    ) => {
      errorsSocialNetwork[field] = "";
      try {
        await schemaSocialNetwork.validateAt(field, formSocialNetwork);

        createTournamentSocialNetwork(formSocialNetwork[field], field);
      } catch (err: any) {
        errorsSocialNetwork[field] = err.message;
      }
    };

    const createTournamentSocialNetwork = async (
      shareText: string,
      socialNetwork: string
    ) => {
      isLoading.value = true;

      var idSocialNetworkType = 0;
      switch (socialNetwork) {
        case "Twitter":
          idSocialNetworkType = SOCIAL_NETWORKS.TWITTER;
          break;
        case "Facebook":
          idSocialNetworkType = SOCIAL_NETWORKS.FACEBOOK;
          break;
        case "Whatsapp":
          idSocialNetworkType = SOCIAL_NETWORKS.WHATSAPP;
          break;
      }

      try {
        const payload = {
          tournamentId: tournament.value.id,
          socialNetworkTypeId: idSocialNetworkType,
          shareText: shareText,
        };

        const response: any = await api.post(
          `/tournament/social-network`,
          payload
        );

        if (response.data != 0) {
          toast.success(
            `Se actualizó con éxito el mensaje de ${socialNetwork}.`,
            {
              timeout: 2000,
            }
          );
        }
      } catch (ex) {
        toast.error(`No se pudo actualizar el mensaje de ${socialNetwork}.`, {
          timeout: 2000,
        });
        console.error(ex);
      } finally {
        isLoading.value = false;
      }
    };

    const createTournamentUploadContentProcess = async () => {
      try {
        tournamentUploadContentProcess.value.tournamentId = tournamentId.value;
        isLoading.value = true;
        const response: any = await api.post(
          `/tournament/tournamentsProcess`,
          tournamentUploadContentProcess.value
        );
        if (response.data != 0) {
          toast.success(
            `El archivo ZIP se está procesando. Podrá descargarlo desde la lista cuando esté listo.`,
            {
              timeout: 2000,
            }
          );
          downloadModal(tournamentId.value);
          isLoading.value = false;
        } else {
          toast.error("Error al generar ZIP.", {
            timeout: 2000,
          });
          isLoading.value = false;
        }
      } catch (ex) {
        toast.error("Error al generar ZIP.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoading.value = false;
      }
    };

    const downloadZip = async (id: number, zipName: string) => {
      try {
        isLoading.value = true;
        const response = await api.get(`/tournament/downloadZip/${id}`, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = zipName;
        link.click();
        isLoading.value = false;
      } catch (error) {
        toast.error("Error al descargar el zip.", {
          timeout: 2000,
        });
        console.error("Error al descargar el zip", error);
        isLoading.value = false;
      }
    };

    return {
      items,
      itemsTournamentStatus,
      itemsCompany,
      itemDownload,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      isModalSocialNetworks,
      tournament,
      formSocialNetwork,
      errorsSocialNetwork,
      computeStatusClass,
      getTournaments,
      fetchPage,
      confirmChangeStatus,
      confirmCloseTournament,
      socialNetworkModal,
      downloadModal,
      validateAndSaveSocialNetwork,
      createTournamentUploadContentProcess,
      tournamentId,
      tournamentUploadContentProcess,
      downloadZip,
      duplicateModal,
      duplicateTournament,
      errors,
      validateForm,
      clearError,
      createTournamentDuplicate,
      closeDuplicateTournament,
    clearDuplicateTournament
    };
  },
});
</script>
